import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlay,
  faPause,
  faRotateRight,
} from "@fortawesome/free-solid-svg-icons";
import { faVolume, faVolumeXmark } from "@fortawesome/pro-solid-svg-icons";
import React, { Component, createRef } from "react";
import "./AudioPlayer.css";
import animatedWaveform from "../../../../Assets/audio-waveform.gif";
import flatWaveform from "../../../../Assets/audio-flat-waveform.gif";
import { AppContext } from "../../../../Util/contexts/AppContext";

export default class AudioPlayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      audioPlayerActive: false,
      audioVolume: 1,
      previousAudioVolume: 1,
      isAudioEnded: false,
      currentAudioSegment: 0,
    };

    const audioFileURL = this.getAudioFileForAccent(
      props.selectedAccent,
      this.state.currentAudioSegment,
      props.audioSegments
    );

    if (audioFileURL) {
      if (props.createURL) {
        this.audioFile = new Audio(URL.createObjectURL(props.mp3Audio));
      } else {
        this.audioFile = new Audio(audioFileURL);
      }
    } else {
      console.error("invalid audio segment");
    }

    this.playRef = createRef();
  }

  static contextType = AppContext;

  getAudioFileForAccent = (selectedAccent, currentAudioSegment) => {
    let accentProperty = null;

    switch (selectedAccent) {
      case "American":
        accentProperty = "americanMp3";
        break;
      case "British":
        accentProperty = "britishMp3";
        break;
      case "Australian":
        accentProperty = "australianMp3";
        break;
      case "Irish":
        accentProperty = "irishMp3";
        break;
      default:
        accentProperty = "americanMp3";
    }

    if (!this.props.audioSegments[currentAudioSegment][accentProperty]) {
      if (this.props.audioSegments[currentAudioSegment].americanMp3)
        selectedAccent = "American";
      else if (this.props.audioSegments[currentAudioSegment].britishMp3)
        selectedAccent = "British";
      else if (this.props.audioSegments[currentAudioSegment].australianMp3)
        selectedAccent = "Australian";
      else if (this.props.audioSegments[currentAudioSegment].irishMp3)
        selectedAccent = "Irish";
      else return null;
    }

    switch (selectedAccent) {
      case "American":
        return `${this.props.route}/getmp3.webapi?FileName=${this.props.audioSegments[currentAudioSegment]?.americanMp3}&Token=${this.props.userData.Token}`;
      case "British":
        return `${this.props.route}/getmp3.webapi?FileName=${this.props.audioSegments[currentAudioSegment]?.britishMp3}&Token=${this.props.userData.Token}`;
      case "Australian":
        return `${this.props.route}/getmp3.webapi?FileName=${this.props.audioSegments[currentAudioSegment]?.australianMp3}&Token=${this.props.userData.Token}`;
      case "Irish":
        return `${this.props.route}/getmp3.webapi?FileName=${this.props.audioSegments[currentAudioSegment]?.irishMp3}&Token=${this.props.userData.Token}`;
      default:
        return `${this.props.route}/getmp3.webapi?FileName=${this.props.audioSegments[currentAudioSegment]?.americanMp3}&Token=${this.props.userData.Token}`;
    }
  };

  attachAudioListeners = () => {
    // Remove existing listeners first
    this.audioFile.removeEventListener("ended", this.handleAudioEnd);
    this.audioFile.removeEventListener("play", this.handleAudioPlay);
    this.audioFile.removeEventListener("pause", this.handleAudioPause);

    this.audioFile.addEventListener("ended", this.handleAudioEnd);
    this.audioFile.addEventListener("play", this.handleAudioPlay);
    this.audioFile.addEventListener("pause", this.handleAudioPause);
  };

  handleAudioEnd = () => {
    if (this.state.currentAudioSegment + 1 < this.props.audioSegments.length) {
      this.setState(
        (prevState) => ({
          currentAudioSegment: prevState.currentAudioSegment + 1,
          isAudioEnded: false,
        }),
        () => {
          this.audioFile = new Audio(
            this.getAudioFileForAccent(
              this.props.selectedAccent,
              this.state.currentAudioSegment,
              this.props.audioSegments
            )
          );
          this.attachAudioListeners();
          this.playAudio();
        }
      );
    } else {
      this.setState({ audioPlayerActive: false, isAudioEnded: true });
    }
  };

  handleAudioPlay = () => {
    this.setState({ audioPlayerActive: true });
  };

  handleAudioPause = () => {
    this.setState({ audioPlayerActive: false });
  };

  componentDidMount() {
    this.attachAudioListeners();
    this.audioFile.currentTime = 0;
    this.playRef = setTimeout(() => this.playAudio(), 0);
  }

  componentWillUnmount() {
    clearTimeout(this.playRef);
    this.pauseAudio();
    this.audioFile.removeEventListener("ended", this.handleAudioEnd);
    this.audioFile.removeEventListener("play", this.handleAudioPlay);
    this.audioFile.removeEventListener("pause", this.handleAudioPause);
  }

  playAudio = async () => {
    await this.audioFile.play();
    this.setState({ audioPlayerActive: true });
  };

  pauseAudio = () => {
    this.audioFile.pause();
    this.setState({ audioPlayerActive: false });
  };

  toggleAudio = () => {
    if (!this.props.showPauseButton && !this.context.userData.PauseButton) {
      return;
    }

    if (this.state.isAudioEnded) {
      this.audioFile.currentTime = 0;
      return this.setState(
        { isAudioEnded: false, currentAudioSegment: 0 },
        () => {
          this.audioFile = new Audio(
            this.getAudioFileForAccent(
              this.props.selectedAccent,
              this.state.currentAudioSegment,
              this.props.audioSegments
            )
          );
          this.attachAudioListeners();
          this.playAudio();
        }
      );
    }

    if (this.state.audioPlayerActive) {
      this.pauseAudio();
    } else {
      this.playAudio();
    }
  };

  muteAudioHandler = () => {
    if (this.state.audioVolume > 0) {
      this.setState({
        previousAudioVolume: this.state.audioVolume,
        audioVolume: 0,
      });
      this.audioFile.volume = 0;
    } else {
      this.setState({
        audioVolume: this.state.previousAudioVolume,
        previousAudioVolume: 1,
      });
      this.audioFile.volume = this.state.previousAudioVolume
        ? this.state.previousAudioVolume
        : 1;
    }
  };

  adjustAudioVolume = (e) => {
    this.setState({ audioVolume: e.target.value });
    this.audioFile.volume = e.target.value;
  };

  render() {
    return (
      <div className="audioComponentContainer">
        <div className="audioAnimationWrapper">
          <div className="audioAnimationContainer">
            {this.state.audioPlayerActive ? (
              <img
                src={animatedWaveform}
                alt="audio animation"
                className="audioGif"
              />
            ) : (
              <img
                src={flatWaveform}
                alt="audio animation"
                className="audioGif"
              />
            )}
          </div>
        </div>
        <div className="audioControlsWrapper">
          <div
            className="audioPlayButtonWrapper"
            onClick={() => this.toggleAudio()}
          >
            {(this.context.userData.PauseButton ||
              this.props.showPauseButton) && (
              <FontAwesomeIcon
                icon={
                  this.state.isAudioEnded
                    ? faRotateRight
                    : this.state.audioPlayerActive
                    ? faPause
                    : faPlay
                }
                className="audioPlayButton"
              />
            )}
          </div>
          <div className="audioVolumeWrapper">
            <FontAwesomeIcon
              icon={this.state.audioVolume > 0 ? faVolume : faVolumeXmark}
              className="audioVolumeButton"
              onClick={this.muteAudioHandler}
            />
            <div className="audioVolumeSliderWrapper">
              <input
                type="range"
                min="0"
                max="1"
                step="0.01"
                value={this.state.audioVolume}
                onChange={this.adjustAudioVolume}
                style={{
                  background: `linear-gradient(to right, white 0%, white ${
                    this.state.audioVolume * 100
                  }%, #292929 ${this.state.audioVolume * 100}%, #292929 100%)`,
                }}
                className="audioVolumeSlider"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
